import Form from "../components/Form/index";

const FormPage = () => {
    return <div className="page"><Form /></div>;
};

export default FormPage;
